import { Layout } from '@docma-mm-core/layout/layout';
import { Structure } from '@docma-mm-core/structure/structure';
import { Project } from '@docma-mm-core/project/project';
import { MmFilterTag } from './tag/mm-filter-tag';
import { Pool } from '../mm-common/pool/pool';

export interface FieldFilter {
  fieldName: string;
  value: string;
  displayValue: string;
}

export class MmFilterModel {

  project: Project;
  layout: Layout;
  structure: Structure;
  tags: MmFilterTag[];
  poolExclusionFilters: Pool[];
  poolInclusionFilters: Pool[];
  fieldFilters: FieldFilter[];

  constructor(init?: Partial<MmFilterModel>) {
    if (init) {
      Object.assign(this, init);
    }
  }

  getTag(id: string): MmFilterTag {
    if (!this.tags) {
      return null;
    }
    return this.tags.find(t=> t.id === id);
  }

  getPoolExclusionFilter(id: number): Pool {
    if (!this.poolExclusionFilters) {
      return null;
    }
    return this.poolExclusionFilters.find(p => p.Id === id);
  }

  getPoolInclusionFilter(id: number): Pool {
    if (!this.poolInclusionFilters) {
      return null;
    }
    return this.poolInclusionFilters.find(p => p.Id === id);
  }

  getFieldFilter(fieldName: string): FieldFilter {
    if (!this.fieldFilters) {
      return null;
    }
    return this.fieldFilters.find(f => f.fieldName === fieldName);
  }

}
